import React, { useState } from 'react';
import { useAuth } from '../../hooks/useAuth';
import './AuthModal.css';

export default function AuthModal({ isOpen, onClose, onSuccess }) {
  const { signInWithGoogle } = useAuth();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleGoogleSignIn = async () => {
    setLoading(true);
    setError(null);
    
    const { user, error: signInError } = await signInWithGoogle();
    
    if (signInError) {
      setError(signInError);
      setLoading(false);
    } else if (user) {
      setLoading(false);
      if (onSuccess) onSuccess(user);
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="auth-modal-overlay" onClick={onClose}>
      <div className="auth-modal-content" onClick={(e) => e.stopPropagation()}>
        <button 
          className="auth-modal-close" 
          onClick={onClose}
          aria-label="Close"
        >
          ×
        </button>
        
        <div className="auth-modal-header">
          <h2>Welcome to Velvynote</h2>
          <p>Sign in to save your memories permanently and access them across devices</p>
        </div>

        {error && (
          <div className="auth-modal-error">
            {error}
          </div>
        )}

        <div className="auth-modal-body">
          <button
            className="auth-button auth-button-google"
            onClick={handleGoogleSignIn}
            disabled={loading}
          >
            {loading ? (
              <span className="auth-button-loading">
                <span className="spinner"></span>
                Signing in...
              </span>
            ) : (
              <>
                <svg className="google-icon" viewBox="0 0 24 24">
                  <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                  <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                  <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                  <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
                </svg>
                Continue with Google
              </>
            )}
          </button>

          <div className="auth-modal-divider">
            <span>or</span>
          </div>

          <div className="auth-modal-info">
            <p className="auth-info-text">
              <strong>Why sign in?</strong>
            </p>
            <ul className="auth-benefits">
              <li>✨ Save memories permanently</li>
              <li>📱 Access from any device</li>
              <li>🔒 Choose which memories stay private</li>
              <li>🎉 Other cool features...</li>
            </ul>
            <p className="auth-info-note">
              You can still browse and create anonymous memories without signing in
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

